import React, { useState } from "react";
import s from "./reportCard.scss";
import cx from "classnames";
import Button from "Components/button/Button";
import TranslatedString from "Components/TranslatedString";

export default function ReportCard({ report, disabled, bannerSlot = "", onGenerate }) {
  const [loading, setLoading] = useState(false);

  const generateReport = async () => {
    setLoading(true);
    await onGenerate(report.type);
    setLoading(false);
  };

  return (
    <React.Fragment>
      <div className={cx(s.card, { [s.disabled]: disabled })}>
        <h2 className={s.title}>
          <TranslatedString>{report.title}</TranslatedString>
        </h2>

        <p className={s.text}>
          <TranslatedString>{report.desc}</TranslatedString>
        </p>
        {bannerSlot}
        <Button className={s.button} loading={loading} color="outline" onClick={generateReport}>
          button.download.report
        </Button>
      </div>
    </React.Fragment>
  );
}
